import { __spreadArray } from "tslib";
import { buildOttHeaders, updateUserTokenFromResponse } from '@sky-uk-ott/client-lib-js-ott-common';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function makeRequestParams(method, contentType, ottHeaders, timeouts, payload, logger) {
    var headers = buildOttHeaders(ottHeaders);
    headers["Accept" /* StandardHttpHeaderConstants.ACCEPT */] = contentType;
    if (contentType) {
        headers["Content-Type" /* StandardHttpHeaderConstants.CONTENT_TYPE */] = contentType;
    }
    var requestParams = {
        method: method,
        headers: headers,
        logger: logger,
        timeouts: timeouts,
    };
    if (payload) {
        requestParams.body = JSON.stringify(payload);
    }
    return requestParams;
}
export function makeTokenizedRequest(contentType, method, standardOTTHeaders, userToken, timeouts, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
payload, logger) {
    var ottHeaders = Object.assign({}, standardOTTHeaders, { userToken: userToken });
    return makeRequestParams(method, contentType, ottHeaders, timeouts, payload, logger);
}
export function tokenizeRequest(request, ovpTokenService, ottHeaders, requestParamsCreator, endpoint, path, timeouts, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
extras, logger) {
    var configuredRequest = function (userToken) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = requestParamsCreator.apply(void 0, __spreadArray([endpoint, ottHeaders, userToken, timeouts, path], args, false)), generatedEndPoint = _a[0], requestOptions = _a[1];
        return request(generatedEndPoint, requestOptions).then(updateUserTokenFromResponse(ovpTokenService, userToken));
    };
    return ovpTokenService.tokenize(configuredRequest, extras, logger);
}
export function unauthenticatedRequest(request, ottHeaders, requestParamsCreator, endpoint, path, timeouts, logger) {
    return function (payload) {
        var _a = requestParamsCreator(endpoint, ottHeaders, timeouts, path, payload, logger), generatedEndPoint = _a[0], requestOptions = _a[1];
        return request(generatedEndPoint, requestOptions);
    };
}
//# sourceMappingURL=request-utils.js.map